import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_jrnl_reference_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  bl_fi_jrnl_hdr_guid: fromDatatype.GuidDataFieldInterface;
  bl_fi_jrnl_line_guid: fromDatatype.GuidDataFieldInterface;
  content_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_jrnl_reference_RowClass implements bl_fi_jrnl_reference_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  bl_fi_jrnl_hdr_guid: fromDatatype.GuidDataFieldInterface;
  bl_fi_jrnl_line_guid: fromDatatype.GuidDataFieldInterface;
  content_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


